import { render, staticRenderFns } from "./SupportItem.vue?vue&type=template&id=4033c702&scoped=true&"
import script from "./SupportItem.vue?vue&type=script&lang=js&"
export * from "./SupportItem.vue?vue&type=script&lang=js&"
import style0 from "./SupportItem.vue?vue&type=style&index=0&id=4033c702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4033c702",
  null
  
)

export default component.exports